import "./testResults.css";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import ServerRequest from "../../ServerRequests/ServerRequest";

const TestResults = () => {
  const [stressPercent, setStressPercent] = useState(0);
  const [depressionPercent, setDepressionPercent] = useState(0);
  const navigate = useNavigate();
  const identifiableData = JSON.parse(localStorage.getItem('testResultsParams')) ?? null;

  useEffect(() => {
    if (!identifiableData) return;
    ServerRequest.identifyUserData(identifiableData);
  }, []);

  useEffect(() => {
    // Отримуємо збережені значення з localStorage
    const savedStress = localStorage.getItem("stressPercent");
    const savedDepression = localStorage.getItem("depressionPercent");

    if (savedStress && savedDepression) {
      // Якщо значення вже є - використовуємо їх
      animateProgress(setStressPercent, parseInt(savedStress));
      animateProgress(setDepressionPercent, parseInt(savedDepression));
    } else {
      // Генеруємо нові випадкові значення із заданих меж
      const newStress = getRandomInRange(66, 77);
      const newDepression = getRandomInRange(19, 29);

      // Зберігаємо нові значення
      localStorage.setItem("stressPercent", newStress.toString());
      localStorage.setItem("depressionPercent", newDepression.toString());

      // Анімуємо прогрес
      animateProgress(setStressPercent, newStress);
      animateProgress(setDepressionPercent, newDepression);
    }
  }, []);

  // Функція для генерації випадкового числа в діапазоні
  const getRandomInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const animateProgress = (setState, target) => {
    let current = 0;
    const duration = 2000;
    const intervalTime = duration / target;

    const interval = setInterval(() => {
      if (current >= target) {
        clearInterval(interval);
      } else {
        current++;
        setState(current);
      }
    }, intervalTime);
  };

  const ProgressBar = ({label, percent}) => {
    return (
      <div className="test-results__progress-container">
        <div className="test-results__block-title">{label}</div>
        <div className="test-results__progress-bar-outer">
          <span
            className="test-results__progress-numbers-main"
            style={{color: percent > 50 ? "#fff" : "#363736"}}
          >
            {percent}%
          </span>
          <div
            className="test-results__progress-bar-inner"
            style={{width: `${percent}%`}}
          ></div>
        </div>
        <div className="test-results__progress-numbers">
          <span className="test-results__progress-start-number">0%</span>
          <span className="test-results__progress-end-number">100%</span>
        </div>
      </div>
    );
  };

  return (
    <div className="test-results__page">
      <div className="test-results__card">
        <h1 className="test-results__title">Výsledky testu</h1>

        <ProgressBar label="Vaša úroveň stresu:" percent={stressPercent}/>
        <ProgressBar
          label="Vaša úroveň depresie:"
          percent={depressionPercent}
        />

        <p className="test-results__description">
          Prejavujete známky vysokej úrovne stresu a sezónnej depresie. Ľudia
          s týmto stavom sa cítia letargicky a vyčerpane a majú problémy so
          spánkom. Mali by ste si dopriať niekoľko dní odpočinku a vyhnúť sa
          dráždivým faktorom.
        </p>

        <div className="test-results__block-title test-results__block-title--big-margin">
          Ďalšie ukazovatele duševného zdravia:
        </div>

        <img
          src={require("./img/diagramm_feeling.png")}
          alt="Ďalšie ukazovatele duševného zdravia:"
          className="test-results__result-image"
        />

        <div className="test-results__block-diagram">
          <button className="test-results__block-diagram-button">
            Celkové skóre: 34
          </button>
        </div>

        <div className="test-results__block-title test-results__block-title--big-margin">
          Rozdelenie bodov v teste duševného zdravia:
        </div>

        <ul className="test-results__points-list">
          <li>
            <strong>0–9 bodov </strong>
            <span>– Žiadny problém. Váš duševný stav je v norme.</span>
          </li>
          <li>
            <strong>10–18 bodov </strong>
            <span>
              – Mierne ťažkosti. Môžu sa objavovať menšie emocionálne výkyvy.
            </span>
          </li>
          <li>
            <strong>19–27 bodov </strong>
            <span>
              – Stredná úroveň ťažkostí. Odporúčame venovať pozornosť tomu,
              ako sa cítite.
            </span>
          </li>
          <li>
            <strong>28–36 bodov </strong>
            <span>
              – Sú prítomné známky možných ťažkostí. Odporúča sa odpočinok a
              podpora.
            </span>
          </li>
          <li>
            <strong>37–45 bodov </strong>
            <span>
              – Stredne závažné problémy. Je čas začať sa starať o svoje
              duševné zdravie.
            </span>
          </li>
          <li>
            <strong>46–54 bodov </strong>
            <span>
              – Výrazné ťažkosti. Odporúča sa konzultácia s odborníkom.
            </span>
          </li>
          <li>
            <strong>55–63 bodov </strong>
            <span>
              – Výrazné problémy. Dôrazne sa odporúča konzultácia s
              odborníkom.
            </span>
          </li>
          <li>
            <strong>64–70 bodov </strong>
            <span>
              – Závažné problémy. Je potrebná okamžitá odborná pomoc.
            </span>
          </li>
        </ul>

        <div className="test-results__block-title test-results__block-title--big-margin">
          Vaša úroveň stresu je nadpriemerná.
        </div>

        <span className="test-results__last-text">
          Znížte ju pomocou vedených meditácií a cvičení dostupných na
          platforme.
        </span>

        <div
          className="test-results__redirect"
          onClick={() => navigate(RoutesToPages.welcomePage)}
        >
          <span className="test-results__redirect-button">Domov</span>
        </div>
      </div>
    </div>
  );
};

export default TestResults;
